import { render, staticRenderFns } from "./ViRecaptchaButton.vue?vue&type=template&id=c0ab1736&"
import script from "./ViRecaptchaButton.vue?vue&type=script&lang=js&"
export * from "./ViRecaptchaButton.vue?vue&type=script&lang=js&"
import style0 from "./ViRecaptchaButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports